import script from "./RunningGamesDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./RunningGamesDashboard.vue?vue&type=script&setup=true&lang=js"

import "./RunningGamesDashboard.vue?vue&type=style&index=0&id=5507537a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5507537a"]])

export default __exports__